import { AmountType, } from '../model/Dish';
import { IntlShape } from 'react-intl';

export function getAmountTypeString(intl: IntlShape, type: AmountType): string {
  if (type === AmountType.Grams) {
    return 'g';
  } else if (type === AmountType.Milliliters) {
    return 'ml';
  } else {
    return intl.formatMessage({ id: "menu.amount-pieces" });
  }
}
